import React from "react";
import PropTypes from "prop-types";
import TableCell from "@material-ui/core/TableCell";
import classnames from "classnames";

const sanitizeRestProps = ({
  cellClassName,
  className,
  field,
  formClassName,
  headerClassName,
  record,
  basePath,
  resource,
  groupIndex,
  ...rest
}) => rest;

const DatagridCell = ({ className, field, record, basePath, resource, groupIndex, ...rest }) => (
  <TableCell
    className={classnames(className, field.props.cellClassName)}
    align={field.props.textAlign}
    {...sanitizeRestProps(rest)}
  >
    {React.cloneElement(field, {
      record,
      basePath: field.props.basePath || basePath,
      resource,
      groupIndex,
    })}
  </TableCell>
);

DatagridCell.propTypes = {
  className: PropTypes.string,
  field: PropTypes.element,
  record: PropTypes.object,
  basePath: PropTypes.string,
  resource: PropTypes.string,
};

// wat? TypeScript looses the displayName if we don't set it explicitly
DatagridCell.displayName = "DatagridCell";

export default DatagridCell;
